import { flagsFromMe } from '@codex/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { AfterPage } from '../../after/after-page.js';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { NotFound } from '../../shell/not-found.js';

/**
 * `/after/:sessionId` (2.F deliverable 2): the session's After page, guarded as every
 * authenticated route is. With the `sessions` flag off it is the not-found page.
 */
export const Route = createFileRoute('/after/$sessionId')({
  staticData: { crumb: 'After' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: AfterRoute,
});

function AfterRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const { sessionId } = Route.useParams();
  if (!flagsFromMe(me).sessions) return <NotFound />;
  return <AfterPage key={sessionId} sessionId={sessionId} />;
}
